import axios from "axios";
import Store from "../store";
import { LOGOUT } from "../store/Types/AuthTypes";
import { BASE_URL } from "../config/apiConfig";
import { toast } from "react-toastify";

const backendValidUserForFile = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

backendValidUserForFile.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("myToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

backendValidUserForFile.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // Sirf unauthorized pe logout
      localStorage.clear();
      Store.dispatch({ type: LOGOUT });
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    } else if (!error.response) {
      // Network error
      toast.error("Network error. Please check your connection.");
    } else if (status >= 500) {
      // Server error — user ko batao, logout nahi
      const msg = error.response?.data?.error?.msg || "Server error occurred. Please try again.";
      toast.error(msg);
    } else if (status === 413) {
      toast.error("File is too large. Please upload a smaller file.");
    } else if (status === 422) {
      toast.error("Invalid data submitted. Please check your inputs.");
    }

    return Promise.reject(error);
  }
);

export default backendValidUserForFile;
